/**
 * ConvertPix — Logo oficial (Pulse Recovery / #01)
 *
 * Uso:
 *  <LogoIcon size={40} />                    // só o ícone
 *  <Logo size={40} variant="dark" />         // ícone + wordmark
 *  <Logo size={40} variant="light" />        // versão pra fundo claro
 */

const G = "#22C55E";

export function LogoIcon({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      data-testid="logo-icon"
      aria-label="ConvertPix"
    >
      <rect x="2" y="2" width="44" height="44" rx="12" fill={G} />
      <path
        d="M10 24 L17 24 L20 14 L26 34 L30 22 L33 26 L38 26"
        stroke="#0A0A0A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function LogoWordmark({ variant = "dark", size = "md" }) {
  const color = variant === "dark" ? "#FFFFFF" : "#0A0A0A";
  const sizeClasses = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-xl",
    xl: "text-2xl",
  };
  return (
    <span
      className={`font-extrabold tracking-tight leading-none ${sizeClasses[size] || sizeClasses.md}`}
      style={{ color, fontFamily: "Manrope, sans-serif" }}
      data-testid="logo-wordmark"
    >
      Convert<span style={{ color: G }}>Pix</span>
    </span>
  );
}

export default function Logo({
  size = 32,
  variant = "dark",
  wordmarkSize = "md",
  className = "",
  showWordmark = true,
}) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo">
      <LogoIcon size={size} />
      {showWordmark && <LogoWordmark variant={variant} size={wordmarkSize} />}
    </div>
  );
}
